// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"755d3cc9","241":"ec08494a","421":"2efc0188","496":"ec5bd10f","514":"765c36b7","663":"2428d260","674":"30e249bc","787":"7ede7ce2"}[chunkId] + ".chunk.js";
};